import React from 'react';
export const SECTION_ID = 'about';
import { staticImageAssets } from 'js/constants/Paths';

import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';

const HeaderRegionPageTemplate = ({ title, description, image = '', isRspbPage }) => {
  return (
    <section
      id={SECTION_ID}
      className={`header-region header-region--${SECTION_ID}`}
      style={{ backgroundImage: image !== '' ? `url(${image})` : 'inherit' }}
    >
      <div className="container">
        {isRspbPage && (
          <img
            className="rsbp__bottom-banner"
            src={staticImageAssets('images/static/rspb-logo.png')}
            alt={'RSPB'}
            title={'RSPB'}
            style={{ position: 'absolute', top: '35px', right: '35px', maxWidth: '100px' }}
          />
        )}
        <div className={`header-region__about-details`}>
          <SvgTextureLineLong color={'#fff'} />
          <h1>{title}</h1>
          <h2>{description}</h2>
        </div>
      </div>
    </section>
  );
};

export default HeaderRegionPageTemplate;
